<template>
  <div class="searchable-package-list">
  <div class="header-search-package-list">
    <el-input
      :value="query"
      prefix-icon="el-icon-search"
      class="query-input"
      placeholder="ค้นหาแพ็กเกจ"
      @input="handleQuery"
    ></el-input>
    <sc-button
      :disabled="disabled"
      class="add-all-button"
      @click="handleClickSelectedAllButton"
    >เลือกทั้งหมด</sc-button>
  </div>
    <div class="list-body">
      <div v-if="noResult" class="empty">{{ emptyText }}</div>
      <package-selector-option
        v-for="item in selectableOptions"
        :key="item.id"
        v-bind="item"
        :can-select="canSelect"
        class="selected-item"
        @select="handleSelect(item)"
      ></package-selector-option>
      <infinite-loading ref="infinite" @infinite="handleInfinite">
        <span slot="no-results"></span>
      </infinite-loading>
    </div>
  </div>
</template>

<script>
import { Input } from "element-ui";
import ScButton from "@/lib/components/ScButton";
import InfiniteLoading from "vue-infinite-loading";
import PackageSelectorOption from "./PackageSelectorOption";

export default {
  components: {
    PackageSelectorOption,
    "el-input": Input,
    ScButton,
    InfiniteLoading
  },
  props: {
    initialPackages: { type: Object, default: null },
    value: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
    query: { type: String, default: "" }
  },
  data() {
    return {};
  },
  computed: {
    selectableOptions() {
      return this.value;
    },
    canSelect() {
      return !this.disabled;
    },
    noResult() {
      return this.selectableOptions.length === 0;
    },
    isEmpty() {
      return this.value.length === 0;
    },
    emptyText() {
      if (this.isEmpty) {
        return "ไม่มีแพ็กเกจ";
      }

      return "ไม่พบแพ็กเกจที่ค้นหา";
    }
  },
  methods: {
    handleSelect(item) {
      this.$emit("select", item);

      if (this.selectableOptions.length < 3) {
        return;
      }

      this.$refs.infinite.attemptLoad();
    },
    handleInfinite($state) {
      this.$emit("end", $state);
    },
    handleQuery(query) {
      this.$emit("query-change", query);
    },
    handleClickSelectedAllButton() {
      this.$emit("addAllPackages");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.searchable-package-list {
  border: $border;
  border-radius: $border-radius;

  .el-input__inner {
    border: 0;
    border-bottom: $border;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;

    height: 43px;
    line-height: 43px;
  }

  > .list-body {
    overflow-y: auto;
    height: 500px;
  }

  > .list-body > .empty {
    padding: 20px 0;
    text-align: center;
  }
}

.header-search-package-list {
  display: grid;
  grid-template-columns: 1fr auto;
  border-bottom: $border;

  > .add-all-button {
    height: 42px;
    font-size: 0.8rem;
    color: #444;
    border: 0;
    border-radius: 0;
    border-top-right-radius: $border-radius;
    border-left: $border;
  }
}
</style>
